'use strict';

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');
var SearchInputContainer = videojs.getComponent('SearchInputContainer');
var SearchContainer = videojs.getComponent('SearchContainer');
/**
 * send mail button.
 */

var Search = function (_Component) {
  inherits(Search, _Component);

  function Search(player, options) {
    classCallCheck(this, Search);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this._createContent();
    return _this;
  }

  Search.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-search'
    });
  };

  Search.prototype._createContent = function _createContent() {
    this.addChild('SearchInputContainer', this);
    this.addChild('SearchContainer', this.options);
  };

  return Search;
}(Component);

function cookiesUserId() {
  var user_id;
  if (getCookieStats("uepUserID") == "") {
    user_id = guid();
    createCookie("uepUserID", user_id, 10 * 365);
    return user_id;
  } else {
    user_id = getCookieStats("uepUserID");
    return user_id;
  }
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function getCookieStats(c_name) {
  var c_start;
  var c_end;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

function createCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}
function formFiltre(type) {
  var types = [];
  if (type) {
    for (var i = 0; i < type.length; i++) {
      types[i] = type[i].value;
    }
    return types;
  }
}
function getData(word, type, page) {
  var HTTP = searchPlayer.searchOptions.api.api_search.HTTP;
  var URL = searchPlayer.searchOptions.api.api_search.URL;
  var videoId = searchPlayer.searchOptions.api.api_search.videoId;
  var client = searchPlayer.searchOptions.api.api_search.client;
  var params = {
    videoId: videoId,
    word: word,
    type: formFiltre(type),
    page: page,
    client: client
  };
  HTTP.get(URL, { params: params }).then(function (response) {
    if (response.data.code === 200) {
      searchPlayer.trigger({ type: "api_search_sucess" }, response.data.data);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}
function formatAnswer(answer, type) {
  var responses;
  var response = { response: "" };
  if (type === "quiz") {
    responses = [];
    for (var i = 0; i < answer.length; i++) {
      response.response = answer[i].id;
      responses.push(response);
    }
  } else {
    responses = answer[0].value;
  }
  return responses;
}
function sendData(answer, options) {
  var HTTP = searchPlayer.searchOptions.api.api_search_post.HTTP;
  var URL = searchPlayer.searchOptions.api.api_search_post.URL;
  var client = searchPlayer.searchOptions.api.api_search_post.client;

  var params = { votes: [{
      "id_inter": options.ref.id,
      "id_user": cookiesUserId(),
      "type": options.type,
      "responses": formatAnswer(answer, options.type)
    }],
    "client": client };
  HTTP.post(URL, params, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {}
  }, function (response) {
    console.log('api error');
    alert('error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}

var Component$1 = videojs.getComponent('Component');
var SearchQuizContainer = videojs.getComponent('SearchQuizContainer');
var SearchQuestionContainer = videojs.getComponent('SearchQuestionContainer');
var SearchChaptersContainer = videojs.getComponent('SearchChaptersContainer');
var self$1 = void 0;
/**
 * send mail button.
 */

var SearchContainer$1 = function (_Component) {
  inherits(SearchContainer, _Component);

  function SearchContainer(player, options) {
    classCallCheck(this, SearchContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    getData();
    self$1 = _this;
    _this.player.on("api_search_sucess", _this._content);

    return _this;
  }

  SearchContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('ul', {
      id: 'vjs-search-container',
      className: 'vjs-search-container'
    });
  };

  SearchContainer.prototype.deleteContent = function deleteContent() {
    videojs.dom.emptyEl(this.el());
  };

  SearchContainer.prototype._content = function _content(event, data) {
    if (self$1.children_.length > 0) {
      self$1.deleteContent();
    }
    var full = {};
    full.data = data;
    for (var i = 0; i < data.length; i++) {
      full.order = i;
      switch (data[i].type) {
        case "chapter":
          self$1.addChild('SearchChaptersContainer', full);
          break;
        case "question":
          self$1.addChild('SearchQuestionContainer', full);
          break;
        case "quiz":
          self$1.addChild('SearchQuizContainer', full);
          break;
        default:
          break;
      }
    }
  };

  return SearchContainer;
}(Component$1);

var ClickableComponent = videojs.getComponent('ClickableComponent');

/**
 * send mail button.
 */

var SearchQuizContainer$1 = function (_ClickableComponent) {
  inherits(SearchQuizContainer, _ClickableComponent);

  function SearchQuizContainer(player, options) {
    classCallCheck(this, SearchQuizContainer);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.player = player;
    _this.data = options.data;
    _this.order = options.order;
    _this.options = options.data[options.order];
    _this.show = "__show";
    _this.title = _this.options.ref.title;
    _this.id = _this.options.ref.id;
    _this.multiple = _this.options.ref.multiple;
    _this.choices = _this.options.ref.quizChoices;
    _this._content(_this.options);
    return _this;
  }

  SearchQuizContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('li', {
      id: 'vjs-search-quiz-container',
      className: 'vjs-search-quiz-container'
    });
  };

  SearchQuizContainer.prototype._content = function _content(options) {
    var full_data = this.data;
    window.submit_quiz = submit_quiz;
    var type = !this.multiple ? "radio" : "checkbox";
    var choices = "";
    var choice = "";
    if (this.choices) {
      for (var i = 0; i < this.choices.length; i++) {
        choice = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"" + type + "\" id=\"" + this.choices[i].id + "\"  value=\"" + this.choices[i].choise + "\" name=\"" + this.id + "\"/>\n    <label for=\"" + this.choices[i].id + "\"></label>\n        <span>" + this.choices[i].choise + "</span>\n    </div>";
        choices = choices + choice;
        choice = "";
      }
    }
    var video_search = "\n        <div class=\"vjs-search-header toggle\" id=\"vjs-search-header\">\n          <span class=\"type_search quiz toggle\">Quiz</span>\n          " + this.title + "\n          <div class=\"time_code toggle\">\n           <span class=\"icon toggle\"></span>\n           <span class=\"time_code_value toggle\">" + this.options.timeCode + "</span>\n          </div>\n         </div>\n        <div class=\"vjs-search-content\" id=\"quiz-content-" + this.options.id + "\">" + choices + ("\n            <div class=\"vjs-survey-entry__action\">\n            <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n            <button class=\"submit\" onclick=\"submit_quiz(" + this.order + ")\" type=\"button\">Continuer</button>\n        </div>\n    </div>\n    ");

    this.el_.innerHTML = video_search;
    function submit_quiz(order) {
      var answer;
      var options = full_data[order];
      answer = document.querySelectorAll('input[name="' + options.ref.id + '"]:checked');
      sendData(answer, options);
    }
  };

  SearchQuizContainer.prototype.handleClick = function handleClick(event) {
    if (event.target && event.target.classList.contains('toggle')) {
      if (this.show === "__show") {
        document.getElementById("quiz-content-" + this.options.id).className += " vjs-search-content__show";
        this.show = "";
      } else {
        document.getElementById("quiz-content-" + this.options.id).className = "vjs-search-content";
        this.show = "__show";
      }
    }
  };

  return SearchQuizContainer;
}(ClickableComponent);

var ClickableComponent$1 = videojs.getComponent('ClickableComponent');
/**
 * send mail button.
 */

var SearchQuestionContainer$1 = function (_ClickableComponent) {
  inherits(SearchQuestionContainer, _ClickableComponent);

  function SearchQuestionContainer(player, options) {
    classCallCheck(this, SearchQuestionContainer);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.player = player;
    _this.data = options.data;
    _this.options = options.data[options.order];
    _this.order = options.order;
    _this.show = "__show";
    _this.question = _this.options.ref.question;
    _this.id = _this.options.ref.id;
    _this.nsp = _this.options.ref.nsp;
    _this._content();
    return _this;
  }

  SearchQuestionContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('li', {
      id: 'vjs-search-question-container',
      className: 'vjs-search-question-container'
    });
  };

  SearchQuestionContainer.prototype._content = function _content() {
    var full_data = this.data;
    window.submit_question = submit_question;
    var nsp = "";
    if (this.nsp) {
      nsp = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"" + this.options.id + "\" value=\"2\"  name=\"resp-" + this.options.id + "\"/>\n    <label for=\"choice_3" + this.options.id + "\"></label>\n        <span>Ne pas r\xE9pondre</span>\n    </div>";
    }
    var comment_search = "\n      <div class=\"vjs-search-header toggle\" id=\"vjs-search-header\">\n        <span class=\"type_search question toggle\">Question</span>\n        " + this.question + "\n        <div class=\"time_code toggle\">\n         <span class=\"icon toggle\"></span>\n         <span class=\"time_code_value toggle\">" + this.options.timeCode + "</span>\n        </div>\n      </div>\n      <div class=\"vjs-search-content\" id=\"question-content-" + this.options.id + "\">\n      \n      <div class=\"vjs-survey-entry__choice\">\n          <input type=\"radio\" id=\"choice_1" + this.options.id + "\"value=\"1\"  name=\"resp-" + this.options.id + "\"/>\n          <label for=\"choice_1" + this.options.id + "\"></label>\n              <span>Oui</span>\n          </div>\n          <div class=\"vjs-survey-entry__choice\">\n          <input type=\"radio\" id=\"choice_2" + this.options.id + "\" value=\"0\" name=\"resp-" + this.options.id + "\"/>\n          <label for=\"choice_2" + this.options.id + "\"></label>\n              <span>Non</span>\n          </div>" + nsp + ("\n          <div class=\"vjs-survey-entry__action\">\n        <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n        <button class=\"submit\" onclick=\"submit_question(" + this.order + ")\" type=\"button\">Continuer</button>\n      </div>\n    </div>\n  ");
    this.el_.innerHTML = comment_search;

    function submit_question(order) {
      var answer;
      var options_question = full_data[order];
      answer = document.querySelectorAll('input[name="resp-' + options_question.id + '"]:checked');
      sendData(answer, options_question);
    }
  };

  SearchQuestionContainer.prototype.handleClick = function handleClick(event) {
    if (event.target && event.target.classList.contains('toggle')) {
      if (this.show === "__show") {
        document.getElementById("question-content-" + this.options.id).className += " vjs-search-content__show";
        this.show = "";
      } else {
        document.getElementById("question-content-" + this.options.id).className = "vjs-search-content";
        this.show = "__show";
      }
    }
  };

  return SearchQuestionContainer;
}(ClickableComponent$1);

var ClickableComponent$2 = videojs.getComponent('ClickableComponent');
/**
 * send mail button.
 */

var SearchChaptersContainer$1 = function (_ClickableComponent) {
  inherits(SearchChaptersContainer, _ClickableComponent);

  function SearchChaptersContainer(player, options) {
    classCallCheck(this, SearchChaptersContainer);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.options = options.data[options.order];
    var timePortions = _this.options.timeCode.split(":");
    _this.timeToSec = parseInt(timePortions[0]) * 3600 + parseInt(timePortions[1]) * 60 + parseInt(timePortions[2]);

    _this._content();
    return _this;
  }

  SearchChaptersContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-search-chapters-container',
      className: 'vjs-search-chapters-container'
    });
  };

  SearchChaptersContainer.prototype._content = function _content() {
    var chapter_search = '\n        <div class="vjs-search-header">\n        <span class="type_search chapter">Chapitre</span> \n        ' + this.options.ref.title + '\n        <div class="time_code">\n           <span class="icon"></span>\n           <span class="time_code_value">' + this.options.timeCode + '</span>\n          </div>\n    ';
    this.el_.innerHTML = chapter_search;
  };

  SearchChaptersContainer.prototype.handleClick = function handleClick() {
    searchPlayer.currentTime(this.timeToSec);
  };

  return SearchChaptersContainer;
}(ClickableComponent$2);

var Component$2 = videojs.getComponent('Component');
var SearchInputWrapper = videojs.getComponent('SearchInput');
var FiltreMenu = videojs.getComponent('FiltreMenu');

/**
 * send mail button.
 */

var SearchInputContainer$1 = function (_Component) {
  inherits(SearchInputContainer, _Component);

  function SearchInputContainer(player, options) {
    classCallCheck(this, SearchInputContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  SearchInputContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-search-input-container',
      className: 'vjs-search-input-container'
    });
  };

  SearchInputContainer.prototype._content = function _content() {
    this.addChild('SearchInputWrapper', SearchInputWrapper);
    this.addChild('FiltreMenu', FiltreMenu);
  };

  return SearchInputContainer;
}(Component$2);

var Component$3 = videojs.getComponent('Component');

/**
 * send mail button.
 */

var SearchInput = function (_Component) {
  inherits(SearchInput, _Component);

  function SearchInput(player, options) {
    classCallCheck(this, SearchInput);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  SearchInput.prototype.createEl = function createEl() {
    return videojs.dom.createEl('input', {
      id: 'vjs-search-input',
      placeholder: 'Recherche...',
      className: 'vjs-search-input'
    });
  };

  return SearchInput;
}(Component$3);

var Button = videojs.getComponent('Button');
var SearchButton = function (_Button) {
  inherits(SearchButton, _Button);

  function SearchButton(player, options) {
    classCallCheck(this, SearchButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-search-button');
    _this.controlText("Rechercher");
    _this.content();
    _this.parent = options;
    _this.player = player;
    return _this;
  }

  SearchButton.prototype.content = function content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="icon_search" x="0px" y="0px" viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve" width="15px" height="15px">\n<path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" fill="rgb(159,159,159)"/></svg>\n';
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  SearchButton.prototype.handleClick = function handleClick() {
    var filtre = document.querySelectorAll("input[name='vjs-filtre-item-checkbox']:checked");
    var text = document.getElementById('vjs-search-input').value;
    getData(text, filtre);
    //this.parent.addComment();
  };

  return SearchButton;
}(Button);

var Button$1 = videojs.getComponent('Button');
/**
 * send mail button.
 */

var FiltreButton = function (_Button) {
  inherits(FiltreButton, _Button);

  function FiltreButton(player, options) {
    classCallCheck(this, FiltreButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-filtre-button');
    _this.controlText("Filtrer");
    _this.content();
    _this.parent = options;
    return _this;
  }

  FiltreButton.prototype.content = function content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="filtre_icon" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 402.577 402.577" style="enable-background:new 0 0 402.577 402.577;" xml:space="preserve">\n<g>\n\t<path d="M400.858,11.427c-3.241-7.421-8.85-11.132-16.854-11.136H18.564c-7.993,0-13.61,3.715-16.846,11.136   c-3.234,7.801-1.903,14.467,3.999,19.985l140.757,140.753v138.755c0,4.955,1.809,9.232,5.424,12.854l73.085,73.083   c3.429,3.614,7.71,5.428,12.851,5.428c2.282,0,4.66-0.479,7.135-1.43c7.426-3.238,11.14-8.851,11.14-16.845V172.166L396.861,31.413   C402.765,25.895,404.093,19.231,400.858,11.427z" fill="rgb(159,159,159)"/>\n</g></svg>\n';
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  FiltreButton.prototype.handleClick = function handleClick() {
    //this.parent.addComment();
  };

  return FiltreButton;
}(Button$1);

var Component$4 = videojs.getComponent('Component');
var FiltreListItem = videojs.getComponent('FiltreListItem');

/**
 * send mail button.
 */

var filtreList = [{
    type: 'quiz',
    name: 'Quiz'
}, {
    type: 'question',
    name: 'Question'
}, {
    type: 'chapters',
    name: 'Chapitres'
}];

var FiltreList = function (_Component) {
    inherits(FiltreList, _Component);

    function FiltreList(player, options) {
        classCallCheck(this, FiltreList);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        _this._content();
        return _this;
    }

    FiltreList.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            id: 'vjs-filtre-list',
            className: 'vjs-filtre-list'
        });
    };

    FiltreList.prototype._content = function _content() {
        if (filtreList.length > 0) {
            for (var i = 0; i < filtreList.length; i++) {
                var filtreItem = this.addChild('FiltreListItem', FiltreListItem);
                filtreItem._content(filtreList[i]);
            }
        }
    };

    return FiltreList;
}(Component$4);

var Component$5 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var FiltreListItem$1 = function (_Component) {
    inherits(FiltreListItem, _Component);

    function FiltreListItem(player, options) {
        classCallCheck(this, FiltreListItem);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        return _this;
    }

    FiltreListItem.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            id: 'vjs-filtre-list-item',
            className: 'vjs-filtre-item'
        });
    };

    //https://jsfiddle.net/codeopus/7tv9jd6o/2/


    FiltreListItem.prototype._content = function _content(filtre) {
        this.el_.id = 'vjs-filtre-item-' + filtre.type;
        var filtreItem = '\n        <input id=\'vjs-filtre-item-checkbox-' + filtre.type + '\' value="' + filtre.type + '" class="vjs-filtre-item-checkbox" name="vjs-filtre-item-checkbox" type="checkbox" />\n        <label for="vjs-filtre-item-checkbox-' + filtre.type + '" class="vjs-filtre-item-value vjs-filtre-item-value-' + filtre.type + '"><span></span>' + filtre.name + '</label>\n    ';
        this.el_.innerHTML = filtreItem;
    };

    return FiltreListItem;
}(Component$5);

var Component$6 = videojs.getComponent('Component');
var FiltreButton$2 = videojs.getComponent('FiltreButton');
var FiltreList$2 = videojs.getComponent('FiltreList');
/**
 * send mail button.
 */

var FiltreMenu$1 = function (_Component) {
  inherits(FiltreMenu, _Component);

  function FiltreMenu(player, options) {
    classCallCheck(this, FiltreMenu);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  FiltreMenu.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-filtre-menu',
      className: 'vjs-filtre-menu'
    });
  };

  FiltreMenu.prototype._content = function _content() {
    this.addChild('FiltreButton', FiltreButton$2);
    this.addChild('FiltreList', FiltreList$2);
  };

  return FiltreMenu;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
var SearchInput$2 = videojs.getComponent('SearchInput');
var SearchButton$2 = videojs.getComponent('SearchButton');

var SearchInputWrapper$1 = function (_Component) {
  inherits(SearchInputWrapper, _Component);

  function SearchInputWrapper(player, options) {
    classCallCheck(this, SearchInputWrapper);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  SearchInputWrapper.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-search-input-wrapper',
      className: 'vjs-search-input-wrapper'
    });
  };

  SearchInputWrapper.prototype._content = function _content() {
    this.addChild('SearchInput', SearchInput$2);
    this.addChild('SearchButton', SearchButton$2);
  };

  return SearchInputWrapper;
}(Component$7);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;


videojs.registerComponent('Search', Search);
videojs.registerComponent('SearchContainer', SearchContainer$1);
videojs.registerComponent('SearchQuizContainer', SearchQuizContainer$1);
videojs.registerComponent('SearchChaptersContainer', SearchChaptersContainer$1);
videojs.registerComponent('SearchContainer', SearchContainer$1);
videojs.registerComponent('SearchQuestionContainer', SearchQuestionContainer$1);
videojs.registerComponent('SearchInputContainer', SearchInputContainer$1);
videojs.registerComponent('SearchInputWrapper', SearchInputWrapper$1);
videojs.registerComponent('SearchInput', SearchInput);
videojs.registerComponent('SearchButton', SearchButton);

videojs.registerComponent('FiltreMenu', FiltreMenu$1);
videojs.registerComponent('FiltreButton', FiltreButton);
videojs.registerComponent('FiltreList', FiltreList);
videojs.registerComponent('FiltreListItem', FiltreListItem$1);

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  window.searchPlayer = player;
  videojs.getComponent('Player').prototype.searchOptions = options;
  player.addClass('vjs-search-player');
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function search
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var search = function search(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('search', search);

// Include the version number.
search.VERSION = version;

module.exports = search;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_search/dist/videojs-search.cjs.js
// module id = 563
// module chunks = 1